import React from "react";
import { get } from "../../../components/Common";
import { useSelector, useDispatch } from "react-redux";
import { AreaTextField } from "../../DesignerCommon";
import AreaSelectField from "../../../components/AreaSelectField";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import FrameAppBar from "../../main_drawer/FrameAppBar";
import Grid from "@material-ui/core/Grid";

// Redux Actions
import { BASIC_SPECS_SECTIONS } from "../../../redux_store/jobState_Schemas";
import { updateAreaSpecification } from "../../../redux_store/jobState";

const useStyles = makeStyles({
    root: {
        background: "#090909ad",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        textAlign: "center",
        paddingTop: "85px",
    },
    grow: {
        flexGrow: 1,
    },
    closeButton: {
        float: "right",
        marginTop: "0px",
        marginRight: "-20px",
        color: "white",
    },
    rowInputCell: {
        padding: "20px",
    },
});

export default (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);

    const { areaIndex } = props;
    const area_length = get(job, "AreaSpecifications." + areaIndex + "." + BASIC_SPECS_SECTIONS.SHAPE + ".Length");
    const area_depth = get(job, "AreaSpecifications." + areaIndex + "." + BASIC_SPECS_SECTIONS.SHAPE + ".Depth");
    const area_design_specs_shape_cutouts = get(
        job,
        "AreaSpecifications." + areaIndex + "." + BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS"
    );

    let backLeftEnabled = area_design_specs_shape_cutouts["BackLeft-CutoutType"] !== "None";
    let backMidEnabled = area_design_specs_shape_cutouts["BackMid-CutoutType"] !== "None";
    let backRightEnabled = area_design_specs_shape_cutouts["BackRight-CutoutType"] !== "None";
    let frontLeftEnabled = area_design_specs_shape_cutouts["FrontLeft-CutoutType"] !== "None";
    let frontRightEnabled = area_design_specs_shape_cutouts["FrontRight-CutoutType"] !== "None";

    return (
        <Paper elevation={20} className={classes.root}>
            <FrameAppBar title={"Edit Cutouts for Area " + (props.areaIndex + 1)} onClick={props.onClose} />
            <div style={{ overflow: "hidden", width: "550px", padding: "8px" }}>
                <Grid container spacing={0}>
                    <Grid className={classes.rowInputCell} item xs={6}>
                        <AreaSelectField
                            label={"Back Left Cutout"}
                            value={area_design_specs_shape_cutouts["FrontLeft-CutoutType"]}
                            items={["None", "Step"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="FrontLeft-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontLeft-CutoutType",
                                        e.target.value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={
                                area_depth - (backLeftEnabled ? area_design_specs_shape_cutouts["BackLeft-WidthY"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["FrontLeft-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontLeft-WidthY",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth ^"
                            min={100}
                            max={
                                area_length -
                                (frontRightEnabled ? area_design_specs_shape_cutouts["FrontRight-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["FrontLeft-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontLeft-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                    </Grid>
                    <Grid className={classes.rowInputCell} item xs={6}>
                        <AreaSelectField
                            label={"Back Right Cutout"}
                            value={area_design_specs_shape_cutouts["BackLeft-CutoutType"]}
                            items={["None", "Step"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="BackLeft-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackLeft-CutoutType",
                                        e.target.value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={area_depth - area_design_specs_shape_cutouts["FrontLeft-WidthY"]}
                            value={area_design_specs_shape_cutouts["BackLeft-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackLeft-WidthY",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth v"
                            min={100}
                            max={
                                area_length -
                                (backRightEnabled ? area_design_specs_shape_cutouts["BackRight-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackLeft-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackLeft-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                    </Grid>

                    <Grid className={classes.rowInputCell} item xs={6}>
                        <AreaSelectField
                            label={"Front Left Cutout"}
                            value={area_design_specs_shape_cutouts["FrontRight-CutoutType"]}
                            items={["None", "Step"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="FrontRight-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontRight-CutoutType",
                                        e.target.value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={area_depth}
                            value={area_design_specs_shape_cutouts["FrontRight-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontRight-WidthY",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth ^"
                            min={100}
                            max={
                                area_length -
                                (frontLeftEnabled ? area_design_specs_shape_cutouts["FrontLeft-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["FrontRight-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontRight-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                    </Grid>
                    <Grid className={classes.rowInputCell} item xs={6}>
                        <AreaSelectField
                            label={"Front Right Cutout"}
                            value={area_design_specs_shape_cutouts["BackRight-CutoutType"]}
                            items={["None", "Step"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="BackRight-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-CutoutType",
                                        e.target.value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={
                                area_depth -
                                (frontRightEnabled ? area_design_specs_shape_cutouts["FrontRight-WidthY"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackRight-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-WidthY",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth v"
                            min={100}
                            max={
                                area_length - (backLeftEnabled ? area_design_specs_shape_cutouts["BackLeft-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackRight-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                    </Grid>
                </Grid>
            </div>
            <div style={{ width: "4px", background: "#CCC", cursor: "e-resize" }}></div>
        </Paper>
    );
};
